import { useFormContext, useWatch , Controller} from "react-hook-form";
import { FormSalesOrderType } from "../types";
import { calculateSummarySalesOrder } from "../utils/functions";
import { BaseTable, NumberInput } from "components";

export const SummaryFooter = () => {
  const { control, getValues } = useFormContext<FormSalesOrderType>();
  const [freight, sodetail] = useWatch({
    control,
    name: ["freight", "sodetail"],
  });
  const summary = calculateSummarySalesOrder({ sodetail, freight });

  return (
    <section className="flex flex-col lg:items-end gap-3">
      <BaseTable
        plain
        className="w-full min-w-[100px] md:max-w-[400px] text-right"
      >
        <tbody>
          <tr>
            <td className="w-[1px] whitespace-nowrap">SUBTOTAL</td>
            <td>{summary?.subtotal?.toLocaleString()}</td>
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">FREIGHT</td>
            <Controller
                control={control}
                name="freight"
                render={({ field, fieldState }) => (
                  <NumberInput
                    textRight
                    value={field.value}
                    readOnly={Boolean(getValues("approval_status") === 4)}
                    ref={field.ref}
                    onValueChange={(value) => field.onChange(value.floatValue)}
                    error={fieldState.error?.message}
                  />
                )}
              />
          </tr>
          <tr>
            <td className="w-[1px] whitespace-nowrap">TAX</td>
            <td>{summary?.tax?.toLocaleString()}</td>
          </tr>
          <tr className="font-bold">
            <td className="w-[1px] whitespace-nowrap">TOTAL AMOUNT</td>
            <td>{summary?.totalAmount?.toLocaleString()}</td>
          </tr>
          <tr className="text-error">
            <td className="w-[1px] whitespace-nowrap">PAYMENT</td>
            <td>{summary?.payment?.toLocaleString()}</td>
          </tr>
          <tr className="border-y-2 border-black text-lg font-bold">
            <td className="w-[1px] whitespace-nowrap">BALANCE</td>
            <td>{summary?.balance?.toLocaleString()}</td>
          </tr>
        </tbody>
      </BaseTable>
    </section>
    // <BaseTable className="w-full min-w-[100px] md:max-w-[400px]">
    //   <tbody className="text-lg  text-end">
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">
    //         SUBTOTAL
    //       </td>
    //       <td className="pt-5">{summary?.subtotal?.toLocaleString()}</td>
    //     </tr>
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">
    //         FREIGHT
    //       </td>
    //       <td className="pt-5"> {summary?.freight?.toLocaleString()}</td>
    //     </tr>
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">
    //         TAX
    //       </td>
    //       <td className="pt-5"> {summary?.tax.toLocaleString()}</td>
    //     </tr>
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">
    //         TOTAL AMOUNT
    //       </td>
    //       <td className="pt-5"> {summary?.totalAmount?.toLocaleString()}</td>
    //     </tr>
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold">
    //         PAYMENT
    //       </td>
    //       <td className="pt-5 text-error"> {summary.payment?.toLocaleString()}</td>
    //     </tr>
    //     <tr className="border-dotted border-b-2">
    //       <td className="w-[1px] whitespace-nowrap pr-3 pt-5 uppercase font-bold text-xl">
    //         BALANCE
    //       </td>
    //       <td className="pt-5 text-xl"> {summary?.balance.toLocaleString()}</td>
    //     </tr>
    //   </tbody>
    // </BaseTable>
  );
};
